// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Badge extends Component {
  getColorStyle(color) {
    switch (color) {
      case 'primary':
        return {
          color: 'white',
          background: colors.pink
        }
      case 'active':
        return {
          color: 'white',
          background: colors.green
        }
      case 'inactive':
        return {
          color: 'black',
          background: colors.grey
        }
      case 'delete':
        return {
          color: 'white',
          background: colors.red
        }
      case 'cancelled':
        return {
          color: 'white',
          background: colors.orange
        }
      default:
        return {
          color: 'black',
          background: colors.grey
        }
    }
  }

  render() {
    const { label, color, style } = this.props
    const colorStyle = this.getColorStyle(color)
    return (
      <span className={css(classes.badge)} style={{ ...style, ...colorStyle }}>
        {label}
      </span>
    )
  }
}

const classes = StyleSheet.create({
  badge: {
    marginLeft: 5,
    padding: '3px 12px',
    fontSize: 12,
    fontWeight: 600,
    border: 'none',
    verticalAlign: 'middle',
    borderRadius: 60,
    letterSpacing: 1,
    // opacity: 0.8,
    textTransform: 'uppercase',
    transition: 'all 0.2s ease-in-out',
    ':focus': {
      outline: 0
    }
  }
})

const BUTTON_COLORS = [
  'default',
  'active',
  'inactive',
  'primary',
  'secondary',
  'delete'
]

Badge.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf(BUTTON_COLORS)
}

export default Badge
